module.exports = __webpack_public_path__ + "static/media/coloured-card-with-btn.df1a1f56.png";